import { AfterViewInit, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-exit-impersonation-confirm-modal',
  templateUrl: './exit-impersonation-confirm-modal.component.html',
  styleUrls: ['./exit-impersonation-confirm-modal.component.scss']
})
export class ExitImpersonationConfirmModalComponent implements AfterViewInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngAfterViewInit() {
      setTimeout(() => {
        const el = document.querySelector('.modal .btn-close') as HTMLElement;
        el?.blur();
      }, 50);
  }

  continue() {
    this.activeModal.close('continue');
  }
}
